import { contentRegistry } from './buildContentRegistry';
export const getCollectionByRoute = (route) => contentRegistry.collectionsByRoute.get(route);
//# sourceMappingURL=getCollectionByRoute.js.map